import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BreadcrumbsState } from './breadcrumbs.state';

/**
 * Definición del selector
 */
export const selectBreadcrumbsState = createFeatureSelector<BreadcrumbsState>('breadcrumbs');

export const getBreadcrums = createSelector(selectBreadcrumbsState, (state: BreadcrumbsState) => state.breadcrumbs);
